import * as React from 'react'

import { Box, Button, Divider, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import BlankSlate from 'modules/reports/components/BlankSlate'
import ErrorBlankSlate from 'modules/reports/components/ErrorBlankSlate'
import { useExecuteReportQuery } from 'modules/reports/hooks/useExecuteReportQuery'
import { useReportExportExcel } from 'modules/reports/hooks/useReportExport'
import { type ReportEditorStore } from 'modules/reports/lib/Store'

import GraphsComponent from './_Graphs'

interface Props {
  store: ReportEditorStore
}

const Visualization = ({ store }: Props) => {
  const [open, toggle] = useToggle(false)
  const reportStruct = store.reportStruct
  const variables = store.variables

  const { fetchData, results, error, loading } = useExecuteReportQuery(store)

  // Fetch data on mount
  useEffect(() => void fetchData(), []) // eslint-disable-line react-hooks/exhaustive-deps

  const { onSubmit: exportReport } = useReportExportExcel({
    reportStruct,
    variables,
  })

  const emptyResults = !results?.rows?.length
  return (
    <Box background="grey000White" height="full">
      <Box width="full" padding="s16" gap="s8" flexDirection="row" justifyContent="flexEnd">
        <Button onClick={fetchData} disabled={loading} iconName="play">
          {i18n.t('reports.sql_editor.run_query')}
        </Button>

        <Tooltip.Dialog
          attachment="top center"
          open={open}
          toggle={toggle}
          label={i18n.t('reports.sql_editor.export_report')}
        >
          <Button type="secondary" onClick={exportReport} iconName="share" />
        </Tooltip.Dialog>
      </Box>
      {loading ? (
        <Loading />
      ) : (
        <Box height="full">
          <Box paddingBottom="s24">
            <Divider />
          </Box>
          {!emptyResults && <GraphsComponent store={store} results={results} />}
          {emptyResults && !error && (
            <BlankSlate
              message={i18n.t('reports.sql_editor.no_results')}
              illustration="task-list-search"
            />
          )}
          {error && <ErrorBlankSlate error={error.data} />}
        </Box>
      )}
    </Box>
  )
}

export default observer(Visualization)
